var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(-147 -797)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1036",
    "data-name": "Rectangle 1036",
    width: 51,
    height: 51,
    transform: "translate(147 797)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(151 803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M129.5,280.317a2.526,2.526,0,0,0-2.954-.912,2.512,2.512,0,0,0-3.93-1.818l-.414.274a2.5,2.5,0,0,0-3.937-1.74c-3.333,2.807-7.375,5.614-8.421,5.614-.765,0-3.1-1.305-4.976-2.351-2.386-1.34-4.646-2.6-5.916-2.7-2.435-.19-9.824,4.126-10.681,4.617a.71.71,0,1,0,.7,1.235c3.018-1.775,8.379-4.519,9.825-4.435.989.07,3.3,1.4,5.347,2.526,2.7,1.509,4.435,2.463,5.523,2.519a.5.5,0,0,0,.147,0h4.912a1.628,1.628,0,0,1,0,3.256h-.049a45.162,45.162,0,0,1-6.835,0c-1.853-.316-4.21-2.414-4.252-2.435h0a.713.713,0,1,0-.955,1.06c.105.1,2.709,2.407,4.976,2.807a18.8,18.8,0,0,0,2.877.162c2.042,0,4.154-.147,4.288-.154a3.06,3.06,0,0,0-.084-6.084h-1.635a63.685,63.685,0,0,0,6.035-4.484,1.095,1.095,0,0,1,1.242,1.8h-.049l-.056.049-.042.049-.028.133v.786a.98.98,0,0,0,.077.084l.049.035.084.063h.049l.105.035h.414a.9.9,0,0,0,.162-.084l2.281-1.41a1.09,1.09,0,0,1,1.256,1.783l-.737.491a.753.753,0,0,0,.863,1.235l.7-.491,1.362-.912a1.1,1.1,0,1,1,1.4,1.691l-.14.1c-7.8,5.432-16.625,11.088-17.923,11.108-.989,0-3.095-1.277-4.976-2.393-2.105-1.27-4.126-2.463-5.544-2.646-2.807-.379-7.179,2.877-7.663,3.27h0a.716.716,0,1,0,.87,1.137c1.193-.919,4.7-3.242,6.6-3,1.13.147,3.179,1.4,5,2.47,2.231,1.333,4.351,2.59,5.705,2.59,2.372,0,16-9.488,18.73-11.389l.063-.056h0a2.519,2.519,0,0,0,.54-3.48Z",
    transform: "translate(-87.912 -256.753)",
    fill: "#366eef",
    stroke: "#366eef",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M231.3,50.414a5.213,5.213,0,1,0-3.678-1.532,5.214,5.214,0,0,0,3.678,1.532Zm0-8.99a3.776,3.776,0,1,1-2.669,1.106A3.774,3.774,0,0,1,231.3,41.424Z",
    transform: "translate(-215.022 -39.986)",
    fill: "#366eef",
    stroke: "#366eef",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M405.637,63.211A4,4,0,1,0,402.8,62.04a4,4,0,0,0,2.835,1.171Zm0-6.575h0a1.066,1.066,0,1,0,0,.007Z",
    transform: "translate(-376.47 -53.99)",
    fill: "#366eef",
    stroke: "#366eef",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M303.98,184.321a5.213,5.213,0,1,0,1.527-3.68A5.206,5.206,0,0,0,303.98,184.321Zm5.207-3.775h0a3.776,3.776,0,1,1-2.669,1.106,3.776,3.776,0,0,1,2.669-1.106Z",
    transform: "translate(-286.651 -167.956)",
    fill: "#366eef",
    stroke: "#366eef",
    strokeWidth: 0.25
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelling);
export default __webpack_public_path__ + "static/media/selling.5265630b9a0fad542d4f266012bba9df.svg";
export { ForwardRef as ReactComponent };